// import axios from 'axios'
import axios from '../../helpers/Axios'

/* eslint-disable no-unused-vars */
export const exportmodule = {

	namespaced: true,

	actions: {

		generatePDF({ commit }, companyId) {
			return axios.post('/export/pdf/' + companyId).then(response => {
				return response.data;
			}).catch(err => {
				console.log(err);
			});
		},
		generateExcel({ commit }, companyId) {
			return axios.post('/export/excel/' + companyId).then(response => {
				return response.data;
			}).catch(err => {
				console.log(err);
			});
		},
		generateFinancialExcel({ commit }, companyId) {
			return axios.post('/export/financial-excel/' + companyId).then(response => {
				return response.data;
			}).catch(err => {
				console.log(err);
			});
		},
		generateAcquisitionExcel({ commit }, companyId) {
			return axios.post('/export/acquisition-excel/' + companyId).then(response => {
				return response.data;
			}).catch(err => {
				console.log(err);
			});		
		},
		searchResultsToExcel({ commit }, [companySearchId, selectedLayout]) {
			return axios.post('/export/search-results-to-excel/' + companySearchId + '/' + selectedLayout).then(response => {
				return response.data;
			}).catch(err => {
				console.log(err);
			});
		},
		selectedSearchResultsToExcel({ commit }, [companySearchId, selectedLayout, results]) {
			return axios.post('/export/selected-search-results-to-excel/' + companySearchId + '/' + selectedLayout, results).then(response => {
				return response.data;
			}).catch(err => {
				console.log(err);
			});
		}
	},
	mutations: {

	}

}
